import { render, staticRenderFns } from "./Riskcomponent.vue?vue&type=template&id=57ac859a&"
import script from "./Riskcomponent.vue?vue&type=script&lang=js&"
export * from "./Riskcomponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports